import { isStringNullOrWhiteSpace } from 'owa-localize';
import isLinkedInButtonDismissed from './isLinkedInButtonDismissed';
import recipientWellLinkedInStore from '../store/linkedInStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import { linkedInStore } from 'owa-linkedin';
import isValidEmailAddress from 'owa-recipient-common/lib/utils/isValidEmailAddress';
import isCacheEmpty from 'owa-recipient-cache/lib/utils/isCacheEmpty';
import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import FindControlViewState, {
    DirectorySearchType,
} from 'owa-recipient-common/lib/store/schema/FindControlViewState';

import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';

export default function shouldShowHeaderFooterItem(
    infoType: FindRecipientInfoType,
    viewState: FindControlViewState
): () => boolean {
    return function(): boolean {
        switch (infoType) {
            case FindRecipientInfoType.Searching:
                return hasQueryString(viewState) && viewState.isSearching;
            case FindRecipientInfoType.TypeToSearch:
                return !hasQueryString(viewState) && isCacheEmpty();
            case FindRecipientInfoType.SearchDirectory:
                return (
                    hasQueryString(viewState) &&
                    !viewState.isSearching &&
                    viewState.directorySearchType == DirectorySearchType.None
                );
            case FindRecipientInfoType.TopNResults:
                return (
                    hasQueryString(viewState) &&
                    !viewState.isSearching &&
                    viewState.directorySearchType != DirectorySearchType.None
                );
            case FindRecipientInfoType.UseAddress:
                return (
                    hasQueryString(viewState) &&
                    viewState.directorySearchType != DirectorySearchType.None &&
                    viewState.findResultSet.length == 0 &&
                    isValidEmailAddress(viewState.queryString)
                );
            case FindRecipientInfoType.SuggestedContacts:
                return !hasQueryString(viewState) && viewState.findResultSet.length > 0;
            case FindRecipientInfoType.FindPeopleFeedback:
                return (
                    isFeatureEnabled('rp-findPeopleSuggestionFeedback') &&
                    shouldUse3SPeopleSuggestions()
                );
            case FindRecipientInfoType.LinkedInAccountBind:
                return (
                    !recipientWellLinkedInStore.bindingPromoClicked &&
                    shouldUse3SPeopleSuggestions() &&
                    isFeatureEnabled('rp-linkedInPeopleSuggestions') &&
                    isUnbound() &&
                    !isLinkedInButtonDismissed()
                );
            default:
                return false;
        }
    };
}

let isUnbound = () => {
    return (
        linkedInStore().status == 'Unbound' ||
        linkedInStore().status == 'LinkedInBound' ||
        linkedInStore().status == 'MicrosoftBound'
    );
};

let hasQueryString = (viewState: FindControlViewState) => {
    return !isStringNullOrWhiteSpace(viewState.queryString);
};
